module.exports = "/wwwroot/img/joining_payment_calculator_page.png?ver=80511f2a";